<template>
  <a-drawer
    :visible="visible"
    width="92vw"
    :closable="true"
    :destroy-on-close="false"
    :body-style="{
      padding: 0,
      height: 'calc(100vh - 55px)',
      overflow: 'hidden',
    }"
    @close="Close"
  >
    <template slot="title">
      <div class="entry-drawer-title">
        <strong>Entry #{{ requestId }}</strong>
        <span>
          <span class="status-label"> Trạng thái: </span>

          <a-tag :color="GetStatusColor(Entry.Status)">
            {{ StatusLabels[Entry.Status] || Entry.Status || "-" }}
          </a-tag>
        </span>

        <span>
          <span class="status-label"> Bước hiện tại: </span>

          {{ StepLabels[Entry.Current_Step] || Entry.Current_Step || "-" }}
        </span>

        <!-- <a-tag color="blue">
                    {{ Entry.Status }}
                </a-tag>

                <span class="entry-drawer-step">
                    {{ Entry.Current_Step_Text }}
                </span>
                <span v-if="OtherPresenceUsers.length" class="entry-presence">
                    <span class="presence-dot"></span>

                    Đang tương tác:
                    {{ PresenceText }}
                </span> -->
        <!-- <div>
                    Entry #{{ requestId }}
                </div>

                <div
                    v-if="OtherPresenceUsers.length"
                    class="entry-presence"
                >
                    <span class="presence-dot"></span>

                    Đang tương tác:
                    {{ PresenceText }}
                </div> -->
      </div>
    </template>

    <a-spin :spinning="IsLoading" class="entry-detail-spin">
      <div
        ref="DetailLayout"
        class="entry-detail-layout"
        :class="{
          'entry-detail-layout--log-collapsed': LogPanelCollapsed,
        }"
      >
        <div class="entry-detail-main">
          <div class="entry-detail-scroll">
            <a-alert
              v-if="HasRemoteChange"
              type="warning"
              show-icon
              closable
              class="remote-update-alert"
              message="Entry vừa được người khác cập nhật."
              description="Các dữ liệu bạn đang nhập vẫn được giữ. Kiểm tra lịch sử bên phải trước khi lưu."
              @close="HasRemoteChange = false"
            />

            <!-- <div class="entry-status-header">
                        <div>
                            <span class="status-label">
                                Trạng thái:
                            </span>

                            <a-tag :color="GetStatusColor(
                                Entry.Status
                            )">
                                {{
                                    Entry.Status ||
                                    '-'
                                }}
                            </a-tag>
                        </div>

                        <div>
                            <span class="status-label">
                                Bước hiện tại:
                            </span>

                            {{
                                StepLabels[
                                Entry.Current_Step
                                ] ||
                                Entry.Current_Step ||
                                '-'
                            }}
                        </div>

                        <div>
                            <span class="status-label">
                                Tiến trình:
                            </span>

                            {{
                                StepLabels[
                                Entry.Progress_Step
                                ] ||
                                Entry.Progress_Step ||
                                '-'
                            }}
                        </div>
                    </div> -->

            <div class="dense-entry-layout">
              <!-- Dòng tóm tắt Entry: không dùng descriptions để tránh mỗi ô quá dài -->
              <div class="entry-summary-strip">
                <div class="summary-cell">
                  <span class="summary-label">Request</span>
                  <strong>#{{ Entry.Request_ID || "-" }}</strong>
                </div>

                <div class="summary-cell">
                  <span class="summary-label">User</span>
                  <strong>{{ Entry.User_ID || "-" }}</strong>
                </div>

                <div class="summary-cell">
                  <span class="summary-label">Mã</span>
                  <strong>{{ Entry.Scratch_Code || "-" }}</strong>
                </div>

                <div class="summary-cell">
                  <span class="summary-label">Kết quả</span>
                  <a-tag
                    class="summary-tag"
                    :color="
                      GetScratchStatusColor(Entry.Scratch_Status) || '#999'
                    "
                  >
                    {{ GetScratchStatusLabel(Entry.Scratch_Status) || "-" }}
                  </a-tag>
                </div>

                <div class="summary-cell">
                  <span class="summary-label">Giải</span>
                  <strong>{{ Entry.AwardType || "-" }}</strong>
                </div>

                <div class="summary-cell">
                  <span class="summary-label">Giá trị</span>
                  <strong>{{ FormatMoney(Entry.Topup_Amount) }}</strong>
                </div>

                <div class="summary-cell summary-cell--wide">
                  <span class="summary-label">Tạo lúc</span>
                  <strong>{{ FormatDateTime(Entry.Created_At) }}</strong>
                </div>
              </div>

              <!-- Customer chỉ là nguồn tham chiếu, không phải form sửa -->
              <div class="customer-reference-bar">
                <div class="customer-reference-title">
                  <a-icon type="idcard" />
                  <strong>Thông tin khách hàng</strong>
                </div>

                <template v-if="Customer">
                  <span class="customer-reference-item">
                    <b>Họ và Tên:</b> {{ Customer.Full_Name || "-" }}
                  </span>

                  <span class="customer-reference-item">
                    <b>CCCD:</b> {{ Customer.CCCD || "-" }}
                  </span>

                  <span class="customer-reference-item">
                    <b>Ngày Sinh:</b> {{ FormatDate(Customer.DoB) }}
                  </span>

                  <span class="customer-reference-item">
                    <b>Giới Tính:</b> {{ Customer.Gender || "-" }}
                  </span>

                  <span
                    class="customer-reference-item customer-reference-address"
                  >
                    <b>Địa Chỉ:</b> {{ Customer.Address || "-" }}
                  </span>

                  <a-button
                    v-if="CanEdit"
                    icon="copy"
                    type="primary"
                    @click="ApplyCustomerProfile"
                  >
                    Áp dụng qua thông tin Trúng Thưởng
                  </a-button>
                </template>

                <span v-else class="muted-text"> Chưa có hồ sơ </span>
              </div>

              <div class="dense-workspace">
                <!-- Cột trái: form Entry dày đặc -->
                <section class="dense-panel profile-panel">
                  <div class="dense-panel-title">
                    <span>
                      <a-icon type="form" />
                      Thông tin trên Entry
                    </span>

                    <small> Lưu sẽ đồng bộ Customer </small>
                  </div>

                  <a-form-model :model="Form" class="dense-form">
                    <div class="dense-form-grid">
                      <label
                        class="dense-field dense-field--name"
                        :class="{
                          'customer-synced-field': SyncedFields.Full_Name,
                        }"
                      >
                        <span>Họ và tên</span>
                        <a-input
                          v-model="Form.Full_Name"
                          size="small"
                          :disabled="!CanEdit"
                        />
                      </label>

                      <label
                        class="dense-field"
                        :class="{
                          'customer-synced-field': SyncedFields.CCCD,
                        }"
                      >
                        <span>CCCD</span>
                        <a-input
                          v-model="Form.CCCD"
                          :min="14"
                          :max="14"
                          size="small"
                          :disabled="!CanEdit"
                        />
                      </label>

                      <label
                        class="dense-field"
                        :class="{
                          'customer-synced-field': SyncedFields.DoB,
                        }"
                      >
                        <span>Ngày sinh</span>
                        <date-input
                          v-model="Form.DoB"
                          :minimum-age="18"
                          :maximum-age="100"
                          :disabled="!CanEdit"
                        />
                      </label>

                      <label
                        class="dense-field dense-field--gender"
                        :class="{
                          'customer-synced-field': SyncedFields.Gender,
                        }"
                      >
                        <span>Giới tính</span>
                        <a-select
                          v-model="Form.Gender"
                          size="small"
                          allow-clear
                          :disabled="!CanEdit"
                        >
                          <a-select-option value="Male">Nam</a-select-option>
                          <a-select-option value="Female">Nữ</a-select-option>
                          <a-select-option value="Other">Khác</a-select-option>
                        </a-select>
                      </label>

                      <label
                        v-if="HasRegion"
                        class="dense-field"
                      >
                        <span>Khu vực</span>

                        <a-select
                          v-model="Form.Region"
                          size="small"
                          style="width: 100%"
                          :disabled="!CanEdit"
                        >
                          <a-select-option
                            v-for="Region in RegionOptions"
                            :key="Region"
                            :value="Region"
                          >
                            {{ Region }}
                          </a-select-option>
                        </a-select>
                      </label>

                      <label
                        class="dense-field dense-field--address"
                        :class="{
                          'customer-synced-field': SyncedFields.Address,
                        }"
                      >
                        <span>Địa chỉ</span>
                        <a-input
                          v-model="Form.Address"
                          size="small"
                          :disabled="!CanEdit"
                        />
                      </label>

                      <label class="dense-field dense-field--note">
                        <span>Ghi chú Entry</span>
                        <a-input
                          v-model="Form.Note"
                          size="small"
                          :disabled="!CanTeleReviewEdit"
                        />
                      </label>

                      <div class="dense-field dense-field--cashout">
                        <span>Hình thức trả thưởng</span>

                        <a-radio-group
                          v-model="Form.IsCashout"
                          button-style="solid"
                          size="small"
                          :disabled="!CanTeleReviewEdit"
                        >
                          <a-radio-button class="payout-voucher" :value="false">
                            <a-icon type="gift" /> VOUCHER
                          </a-radio-button>

                          <a-radio-button class="payout-cash" :value="true">
                            <i class="fa fa-money" aria-hidden="true"></i> TIỀN MẶT
                          </a-radio-button>
                        </a-radio-group>
                      </div>
                    </div>
                  </a-form-model>

                  <div
                    class="supervisor-inline"
                    :class="{
                      'supervisor-inline--review': IsReReviewStatus,
                    }"
                  >
                    <div class="supervisor-inline__head">
                      <strong>Supervisor</strong>

                      <span>
                        {{ Entry.Last_Supervisor || "Chưa xử lý" }}
                      </span>

                      <span>
                        {{ FormatDateTime(Entry.SuperVisor_Action_Time) }}
                      </span>
                    </div>

                    <div class="supervisor-inline__comment">
                      <div
                        v-if="IsReReviewStatus"
                        class="supervisor-review-label"
                      >
                        <a-icon type="exclamation-circle" />
                        Nội dung cần điều chỉnh
                      </div>

                      <a-textarea
                        v-if="IsSupervisor"
                        v-model="Form.SuperVisor_Comment"
                        :rows="2"
                        :max-length="500"
                        placeholder="Nhập nhận xét Supervisor..."
                      />

                      <div v-else class="supervisor-comment-readonly">
                        {{
                          Entry.SuperVisor_Comment ||
                          (IsReReviewStatus
                            ? "Chưa có nội dung yêu cầu điều chỉnh."
                            : "Chưa có nhận xét từ Supervisor")
                        }}
                      </div>
                    </div>
                  </div>
                </section>

                <!-- Cột phải: 2 nhóm ảnh nằm cạnh nhau -->
                <section ref="ImagePanel" class="dense-panel image-panel">
                  <div class="dense-panel-title">
                    <span>
                      <a-icon type="picture" />
                      Hình ảnh xác minh
                    </span>
                  </div>

                  <div class="compact-image-groups">
                    <div class="compact-image-group">
                      <div class="compact-image-group__head">
                        <strong>Mã trúng thưởng</strong>

                        <a-tag
                          :color="
                            Entry.IsScratch_Code_Image_Verified
                              ? '#00CF00'
                              : '#f50'
                          "
                        >
                          {{
                            Entry.IsScratch_Code_Image_Verified
                              ? "Đã xác nhận"
                              : "Chưa xác nhận"
                          }}
                        </a-tag>
                      </div>

                      <div class="compact-thumbnails">
                        <div
                          class="compact-thumb compact-thumb--clickable"
                          @click="
                            OpenImagePreview(
                              'Mã trúng thưởng - Ảnh gốc',
                              Entry.Customer_Scratch_Code_Image,
                            )
                          "
                        >
                          <span>Gốc</span>
                          <img
                            v-if="Entry.Customer_Scratch_Code_Image"
                            :src="
                              ResolveImage(Entry.Customer_Scratch_Code_Image)
                            "
                            alt=""
                            title="Bấm để xem ảnh lớn"
                          />
                          <a-empty
                            v-else
                            :image-style="{ height: '28px' }"
                            description=""
                          />
                        </div>

                        <div
                          class="compact-thumb compact-thumb--clickable"
                          @click="
                            OpenImagePreview(
                              'Mã trúng thưởng - Ảnh xác minh',
                              Entry.Scratch_Code_Image,
                            )
                          "
                        >
                          <span>Xác minh</span>
                          <img
                            v-if="Entry.Scratch_Code_Image"
                            :src="ResolveImage(Entry.Scratch_Code_Image)"
                            alt=""
                            title="Bấm để xem ảnh lớn"
                          />
                          <a-empty
                            v-else
                            :image-style="{ height: '28px' }"
                            description=""
                          />
                        </div>
                      </div>

                      <a-input
                        v-model="Form.Scratch_Code_Image_Note"
                        size="small"
                        :disabled="!CanEdit"
                        placeholder="Ghi chú ảnh mã"
                      />

                      <div class="compact-image-actions">
                        <a-button
                          type="primary"
                          size="small"
                          icon="check"
                          :disabled="!CanEdit || !Entry.Scratch_Code_Image"
                          :loading="VerifyLoading === 'SCRATCH_CODE'"
                          @click="VerifyImage('SCRATCH_CODE')"
                        >
                          Xác nhận đúng thông tin
                        </a-button>

                        <a-button
                          size="small"
                          icon="upload"
                          :disabled="!CanEdit"
                          @click="$refs.ScratchUpload.click()"
                        >
                          Tải ảnh thay thế
                        </a-button>

                        <input
                          ref="ScratchUpload"
                          type="file"
                          accept="image/*"
                          class="hidden-upload-input"
                          @change="OnFileSelected('SCRATCH_CODE', $event)"
                        />
                      </div>
                    </div>

                    <div class="compact-image-group">
                      <div class="compact-image-group__head">
                        <strong>CCCD</strong>

                        <a-tag
                          :color="
                            Entry.IsCCCD_Image_Verified ? '#00CF00' : '#f50'
                          "
                        >
                          {{
                            Entry.IsCCCD_Image_Verified
                              ? "Đã xác nhận"
                              : "Chưa xác nhận"
                          }}
                        </a-tag>
                      </div>

                      <div class="compact-thumbnails">
                        <div
                          class="compact-thumb compact-thumb--clickable"
                          @click="
                            OpenImagePreview(
                              'CCCD - Ảnh gốc',
                              Entry.Customer_CCCD_Image,
                            )
                          "
                        >
                          <span>Gốc</span>
                          <img
                            v-if="Entry.Customer_CCCD_Image"
                            :src="ResolveImage(Entry.Customer_CCCD_Image)"
                            alt=""
                            title="Bấm để xem ảnh lớn"
                          />
                          <a-empty
                            v-else
                            :image-style="{ height: '28px' }"
                            description=""
                          />
                        </div>

                        <div
                          class="compact-thumb compact-thumb--clickable"
                          @click="
                            OpenImagePreview(
                              'CCCD - Ảnh xác minh',
                              Entry.CCCD_Image,
                            )
                          "
                        >
                          <span>Xác minh</span>
                          <img
                            v-if="Entry.CCCD_Image"
                            :src="ResolveImage(Entry.CCCD_Image)"
                            alt=""
                            title="Bấm để xem ảnh lớn"
                          />
                          <a-empty
                            v-else
                            :image-style="{ height: '28px' }"
                            description=""
                          />
                        </div>
                      </div>

                      <a-input
                        v-model="Form.CCCD_Image_Note"
                        size="small"
                        :disabled="!CanEdit"
                        placeholder="Ghi chú ảnh CCCD"
                      />

                      <div class="compact-image-actions">
                        <a-button
                          type="primary"
                          size="small"
                          icon="check"
                          :disabled="!CanEdit || !Entry.CCCD_Image"
                          :loading="VerifyLoading === 'CCCD'"
                          @click="VerifyImage('CCCD')"
                        >
                          Xác nhận đúng thông tin
                        </a-button>

                        <a-button
                          size="small"
                          icon="upload"
                          :disabled="!CanEdit"
                          @click="$refs.CCCDUpload.click()"
                        >
                          Tải ảnh thay thế
                        </a-button>

                        <input
                          ref="CCCDUpload"
                          type="file"
                          accept="image/*"
                          class="hidden-upload-input"
                          @change="OnFileSelected('CCCD', $event)"
                        />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>

            <div v-if="ShowVoucherPanel" class="voucher-supervisor-panel">
              <div class="voucher-panel-header">
                <div class="voucher-panel-title">
                  <a-icon :type="IsCashoutEntry ? 'dollar' : 'gift'" />
                  <strong>
                    {{
                      IsCashoutEntry
                        ? "Trả thưởng tiền mặt"
                        : "Thông tin voucher"
                    }}
                  </strong>
                </div>

                <div class="voucher-panel-header-actions">
                  <a-button
                    v-if="!IsCashoutEntry"
                    type="primary"
                    size="small"
                    icon="calculator"
                    :loading="VoucherCountCheckLoading"
                    @click="CheckVoucherCount"
                  >
                    KIỂM TRA SỐ LƯỢNG VOUCHER
                  </a-button>

                  <a-tag :color="GetStatusColor(Entry.Status)">
                    {{ StatusLabels[Entry.Status] || Entry.Status || "-" }}
                  </a-tag>
                </div>
              </div>

              <a-alert
                v-if="!IsCashoutEntry && Entry.Status === 'SENT_VOUCHER'"
                type="success"
                show-icon
                class="voucher-ready-alert"
                message="Đã lấy voucher thành công."
                description="Vui lòng kiểm tra mã và bấm Gửi voucher đến Zalo KH."
              />

              <a-alert
                v-if="!IsCashoutEntry && HasVoucherDLR"
                :type="GetVoucherDLRAlertType(Entry.Voucher_Distribution_DLR_Status)"
                show-icon
                class="voucher-ready-alert"
                :message="GetVoucherDLRStatusLabel(Entry.Voucher_Distribution_DLR_Status)"
                :description="GetVoucherDLRDescription()"
              />

              <div
                v-if="!IsCashoutEntry && HasVoucherDLR"
                class="voucher-dlr-grid"
              >
                <div class="voucher-info-row">
                  <span>Tracking ID</span>
                  <code>{{ Entry.Voucher_Distribution_Response_ID || "-" }}</code>
                </div>

                <div class="voucher-info-row">
                  <span>Nguồn xác nhận</span>
                  <strong>{{ GetVoucherDLRSourceLabel(Entry.Voucher_Distribution_DLR_Source) }}</strong>
                </div>

                <div class="voucher-info-row">
                  <span>DLR cập nhật</span>
                  <strong>{{ FormatDateTime(Entry.Voucher_Distribution_DLR_Updated_At) }}</strong>
                </div>

                <div class="voucher-info-row">
                  <span>Gửi thành công</span>
                  <strong>{{ FormatDateTime(Entry.Voucher_Distribution_DLR_Delivered_At || Entry.Distributed_Time) }}</strong>
                </div>
              </div>

              <a-alert
                v-if="IsCashoutEntry"
                :type="Entry.IsDistributed ? 'success' : 'info'"
                show-icon
                class="voucher-ready-alert"
                :message="
                  Entry.IsDistributed
                    ? 'Đã hoàn tất trả thưởng tiền mặt.'
                    : 'Entry được trả thưởng bằng tiền mặt.'
                "
                :description="
                  Entry.SuperVisor_Cashout_Accept
                    ? 'Supervisor đã chấp thuận hình thức trả thưởng tiền mặt.'
                    : 'Đang chờ Supervisor chấp thuận.'
                "
              />

              <div v-if="!IsCashoutEntry" class="voucher-info-grid">
                <div
                  v-for="Voucher in VoucherItems"
                  :key="Voucher.Index"
                  class="voucher-info-card"
                >
                  <div class="voucher-info-card__header">
                    <strong> Voucher {{ Voucher.Index }} </strong>

                    <a-tag :color="GetVoucherStageColor(Voucher.Status)">
                      {{ GetVoucherStageLabel(Voucher.Status) }}
                    </a-tag>
                  </div>

                  <div class="voucher-info-row">
                    <span>Mã voucher</span>
                    <code>{{ Voucher.Code || "-" }}</code>
                  </div>

                  <div class="voucher-info-row">
                    <span>Voucher ID</span>
                    <strong>{{ Voucher.ID || "-" }}</strong>
                  </div>

                  <div class="voucher-info-row">
                    <span>Request lấy</span>
                    <strong>{{ Voucher.RequestID || "-" }}</strong>
                  </div>

                  <div class="voucher-info-row">
                    <span>Ngày lấy</span>
                    <strong>{{ FormatDateTime(Voucher.TakenAt) }}</strong>
                  </div>

                  <div class="voucher-info-row">
                    <span>Hết hạn</span>
                    <strong>{{ FormatDate(Voucher.Expired) }}</strong>
                  </div>

                  <a-button
                    block
                    type="primary"
                    size="small"
                    icon="search"
                    :disabled="!Voucher.Code"
                    :loading="VoucherCheckLoading === Voucher.Index"
                    @click="CheckVoucherUsage(Voucher.Index)"
                  >
                    Double-check Request ID sử dụng mã
                  </a-button>

                  <a-alert
                    v-if="VoucherChecks[Voucher.Index]"
                    show-icon
                    class="voucher-check-result"
                    :type="
                      VoucherChecks[Voucher.Index].Has_Conflict
                        ? 'error'
                        : 'success'
                    "
                    :message="
                      GetVoucherCheckMessage(VoucherChecks[Voucher.Index])
                    "
                  />
                </div>
              </div>

              <a-divider orientation="left">
                {{
                  IsCashoutEntry
                    ? "Thông tin trả thưởng tiền mặt"
                    : "Thông tin gửi voucher"
                }}
              </a-divider>

              <div v-if="IsCashoutEntry" class="voucher-send-summary">
                <div>
                  <span>Hình thức</span>
                  <strong>TIỀN MẶT</strong>
                </div>

                <div>
                  <span>Supervisor duyệt</span>
                  <a-tag
                    :color="
                      Entry.SuperVisor_Cashout_Accept ? 'green' : 'orange'
                    "
                  >
                    {{
                      Entry.SuperVisor_Cashout_Accept
                        ? "Đã chấp thuận"
                        : "Chưa chấp thuận"
                    }}
                  </a-tag>
                </div>

                <div>
                  <span>Bắt đầu trả</span>
                  <strong>
                    {{ FormatDateTime(Entry.Start_Distribution_Time) }}
                  </strong>
                </div>

                <div>
                  <span>Hoàn tất</span>
                  <strong>
                    {{ FormatDateTime(Entry.Distributed_Time) }}
                  </strong>
                </div>
              </div>

              <div v-else class="voucher-send-summary">
                <div>
                  <span>Bắt đầu gửi</span>
                  <strong>{{
                    FormatDateTime(Entry.Start_Distribution_Time)
                  }}</strong>
                </div>

                <div>
                  <span>Nhận phản hồi</span>
                  <strong>
                    {{ FormatDateTime(VoucherDistributionResponseTime) }}
                  </strong>
                </div>

                <div>
                  <span>Hoàn tất</span>
                  <strong>{{ FormatDateTime(Entry.Distributed_Time) }}</strong>
                </div>

                <div>
                  <span>Phân phối</span>
                  <a-tag :color="Entry.IsDistributed ? 'green' : 'default'">
                    {{
                      Entry.IsDistributed
                        ? "Đã gửi thành công"
                        : "Chưa hoàn tất"
                    }}
                  </a-tag>
                </div>
              </div>

              <div
                v-if="!IsCashoutEntry && VoucherSendResponseText"
                class="voucher-zalo-response"
              >
                <div class="voucher-response-title">
                  Zalo response / lỗi gửi
                </div>
                <pre>{{ VoucherSendResponseText }}</pre>
              </div>

              <div v-if="VoucherActions.length" class="voucher-action-list">
                <a-button
                  v-for="Action in VoucherActions"
                  :key="Action.Code"
                  :type="Action.Type || 'primary'"
                  :loading="ActionLoading === Action.Code"
                  @click="RunAction(Action)"
                >
                  {{ Action.Label }}
                </a-button>
              </div>
            </div>
          </div>

          <div class="entry-action-footer">
            <div>
              <a-button
                v-if="CanEdit"
                type="primary"
                icon="save"
                :loading="IsSaving"
                :disabled="!IsDirty"
                @click="SaveEntry"
              >
                Lưu thay đổi
              </a-button>
            </div>

            <div class="business-action-list">
              <a-button
                v-for="Action in ReviewActions"
                :key="Action.Code"
                :type="
                  Action.Type ||
                  (Action.Code === 'APPROVED' ? 'primary' : 'default')
                "
                :loading="ActionLoading === Action.Code"
                @click="RunAction(Action)"
              >
                {{ Action.Label }}
              </a-button>
            </div>
          </div>
        </div>

        <div
          class="entry-log-viewport"
          :class="{
            'entry-log-viewport--collapsed': LogPanelCollapsed,
          }"
        >
          <EntryLogPanel
            :logs="LocalizedLogs"
            :loading="IsLoadingLogs"
            :has-more="HasMoreLogs"
            :collapsed="LogPanelCollapsed"
            @load-more="LoadMoreLogs"
            @toggle-collapse="
              LogPanelCollapsed = !LogPanelCollapsed
            "
          />
        </div>

        <!--
                    Preview ảnh lớn:
                    - Không thay đổi grid Main + Log.
                    - Không làm co form bên trái.
                    - Bắt đầu đúng từ mép trái image-panel.
                    - Phủ qua toàn bộ log-panel tới mép phải Drawer.
                -->
        <aside
          v-if="ImagePreview.Visible"
          class="entry-image-preview-panel"
          :style="{
            left: ImagePreview.Left + 'px',
          }"
        >
          <div class="entry-image-preview-head">
            <div>
              <a-icon type="picture" />
              <strong>
                {{ ImagePreview.Title }}
              </strong>
            </div>

            <a-button
              type="link"
              size="small"
              icon="close"
              @click="CloseImagePreview"
            >
              Đóng hình ảnh
            </a-button>
          </div>

          <div
            ref="PreviewBody"
            class="entry-image-preview-body"
            @wheel.prevent="ZoomPreviewImage"
            @mousemove="MovePreviewDrag"
            @mouseup="EndPreviewDrag"
            @mouseleave="EndPreviewDrag"
          >
            <div class="entry-image-preview-tools">
              <a-button type="primary" icon="close" @click="CloseImagePreview">
                ĐÓNG
              </a-button>

              <a-tooltip title="Xoay trái 90°">
                <a-button @click="RotatePreviewImage(-90)">
                  <img
                    class="rotate-icon"
                    :src="require('@/assets/rotate-left.png')"
                    alt="Xoay trái"
                  />
                </a-button>
              </a-tooltip>

              <a-tooltip title="Xoay phải 90°">
                <a-button @click="RotatePreviewImage(90)">
                  <img
                    class="rotate-icon"
                    :src="require('@/assets/rotate-right.png')"
                    alt="Xoay phải"
                  />
                </a-button>
              </a-tooltip>
            </div>

            <img
              v-if="ImagePreview.Path"
              ref="PreviewImage"
              class="entry-image-preview-image"
              :src="ResolveImage(ImagePreview.Path)"
              :alt="ImagePreview.Title"
              :style="{
                transform:
                  'scale(' +
                  ImagePreview.Zoom +
                  ') rotate(' +
                  ImagePreview.Rotation +
                  'deg)',
                transformOrigin:
                  ImagePreview.OriginX + '% ' + ImagePreview.OriginY + '%',
                left: ImagePreview.PanX + 'px',
                top: ImagePreview.PanY + 'px',
                cursor:
                  ImagePreview.Zoom > 1
                    ? ImagePreview.Dragging
                      ? 'grabbing'
                      : 'grab'
                    : 'zoom-in',
              }"
              draggable="false"
              @mousedown.left.prevent="StartPreviewDrag"
              @click="TogglePreviewZoom"
            />

            <a-empty v-else description="Không có ảnh" />
          </div>

          <div class="entry-image-preview-foot">
            Có thể tiếp tục nhập/chỉnh thông tin CCCD ở khung bên trái.
          </div>
        </aside>
      </div>
    </a-spin>
  </a-drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CRMEntrySocket from "@/CRM_Entry_Socket";
import EntryLogPanel from "./EntryLogPanel.vue";
import DateInput from "@/components/DateInput.vue";
const moment = require("moment");
const EDITABLE_FIELDS = [
  "Full_Name",
  "CCCD",
  "Address",
  "DoB",
  "Gender",
  "Region",
  "Note",
  "IsCashout",
  "Scratch_Code_Image_Note",
  "CCCD_Image_Note",
];

export default {
  name: "EntryDetailDrawer",

  components: {
    EntryLogPanel,
    DateInput,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    requestId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      IsLoading: false,
      IsSaving: false,
      IsLoadingLogs: false,

      VerifyLoading: "",
      UploadLoading: "",
      ActionLoading: "",
      VoucherCheckLoading: "",
      VoucherCountCheckLoading: false,

      Entry: {},
      Customer: null,

      Form: {},
      OriginalForm: {},

      Logs: [],
      LogsPage: 1,
      LogsPageSize: 30,
      HasMoreLogs: false,

      LogPanelCollapsed: true,

      PresenceUsers: [],
      HasRemoteChange: false,

      ImagePreview: {
        Visible: false,
        Title: "",
        Path: "",
        Left: 0,

        Zoom: 1,
        OriginX: 50,
        OriginY: 50,
        Rotation: 0,

        PanX: 0,
        PanY: 0,
        Dragging: false,
        DragMoved: false,
        DragStartX: 0,
        DragStartY: 0,
        PanStartX: 0,
        PanStartY: 0,
      },
      Scratch_StatusColors: {
        SUCCESS: "#00CF00",
        WRONG: "#E5211D",
        DUPLICATE: "#FFA500",
        BLOCK: "#E5211D",
        BLACKLIST: "#E5211D",
        ENDDATE: "#E5211D",
        NOTYET: "#E5211D",
      },
      Scratch_StatusLabels: {
        SUCCESS: "Mã hợp lệ",
        WRONG: "Không chính xác",
        DUPLICATE: "Mã sử dụng",
        BLOCK: "KH tạm khóa",
        BLACKLIST: "KH đã khóa",
        ENDDATE: "CT Kết thúc",
        NOTYET: "CT Chưa bắt đầu",
      },

      RegionOptions: [
        "Sông Tiền",
        "Nam Trung Bộ",
        "Tây Nguyên",
        "Trung Tâm",
        "Miền Đông",
        "Sông Hậu",
      ],

      Permissions: {},
      AvailableActions: [],

      VoucherChecks: {
        1: null,
        2: null,
      },

      SyncedFields: {
        Full_Name: false,
        CCCD: false,
        Address: false,
        DoB: false,
        Gender: false,
      },

      StatusLabels: {
        IN_REVIEW: "Chờ kiểm duyệt",
        PENDING: "Chờ Supervisor",
        VERIFIED: "Đã xác minh",
        RE_REVIEW: "Kiểm duyệt lại",
        APPROVED: "Đã duyệt",
        GET_VOUCHER: "Đang lấy voucher",
        VOUCHER_ISSUED: "Lấy voucher thất bại",
        SENT_VOUCHER: "Đã lấy voucher",
        SENT_ISSUED: "Gửi voucher thất bại",
        COMPLETED: "Hoàn thành",
        REJECTED: "Từ chối",
      },

      StepLabels: {
        VerifiedCustInfo: "Xác minh thông tin khách hàng",

        SupReview: "Supervisor kiểm tra",

        SupApproved: "Supervisor đã duyệt",

        GetVoucher: "Đang lấy voucher",

        SentVoucher: "Đã lấy voucher / chờ gửi",

        VoucherDistributed: "Voucher đã được phân phối",

        Completed: "Hoàn thành",

        Rejected: "Đã từ chối",
      },
    };
  },

  computed: {
    ...mapState(["isLogin", "oUser"]),
    // oUser() {
    //     return this.$store.state.oUser || {};
    // },
    LocalizedLogs() {
      return (this.Logs || []).map((Log) => {
        const Result = {
          ...Log,
        };

        const EventCode = String(
          Log.Event || Log.Action || Log.Modified_Short_Code || "",
        ).toUpperCase();

        const EventLabels = {
          CREATE: "Tạo Entry",
          CREATED: "Tạo Entry",
          UPDATE: "Cập nhật Entry",
          UPDATED: "Cập nhật Entry",
          SAVE: "Lưu thay đổi",
          VERIFIED: "Xác minh thông tin",
          VERIFY_IMAGE: "Xác minh hình ảnh",
          VERIFY_SCRATCH_IMAGE: "Xác minh ảnh mã",
          VERIFY_CCCD_IMAGE: "Xác minh ảnh CCCD",
          APPROVED: "Duyệt Entry",
          RE_REVIEW: "Yêu cầu duyệt lại",
          REQUEST_REVIEW: "Yêu cầu duyệt lại",
          REQUEST_RE_REVIEW: "Yêu cầu duyệt lại",
          REJECTED: "Từ chối Entry",
          GET_VOUCHER: "Lấy voucher",
          GETVOUCHER: "Lấy voucher",
          VOUCHER_ISSUED: "Lấy voucher thất bại",
          VOUCHERISSUED: "Lấy voucher thất bại",
          SEND_VOUCHER: "Gửi voucher đến Zalo KH",
          SENT_VOUCHER: "Đã lấy voucher",
          SENTVOUCHER: "Gửi voucher đến Zalo KH",
          SENT_ISSUED: "Gửi voucher thất bại",
          SENTISSUED: "Gửi voucher thất bại",
          DISTRIBUTE_VOUCHER: "Phân phối voucher",
          CASHOUTCOMPLETED: "Hoàn tất trả thưởng tiền mặt",
          COMPLETE_CASHOUT: "Hoàn tất trả thưởng tiền mặt",
          COMPLETED: "Hoàn tất Entry",
          APPLY_CUSTOMER_PROFILE: "Áp dụng hồ sơ khách hàng",
          CUSTOMER_SYNC: "Đồng bộ hồ sơ khách hàng",
          SOCKET_UPDATE: "Cập nhật thời gian thực",
          DLR_WAITING: "ZNS đang chờ xác nhận gửi",
          DLR_DELIVERED: "ZNS xác nhận gửi thành công",
          DLR_FAILED: "ZNS xác nhận gửi thất bại",
        };

        const EventText =
          EventLabels[EventCode] ||
          Log.Event_Text ||
          Log.Action_Text ||
          Log.Event ||
          Log.Action ||
          Log.Modified_Short_Code ||
          "Cập nhật Entry";

        /*
         * Ghi đè tất cả alias thường được
         * EntryLogPanel dùng để hiển thị.
         */
        Result.Event = EventText;
        Result.Event_Text = EventText;
        Result.Action = EventText;
        Result.Action_Text = EventText;
        Result.Modified_Short_Code = EventText;

        return Result;
      });
    },

    HasVoucherDLR() {
      return !!(
        String(this.Entry.Voucher_Distribution_DLR_Status || "").trim() ||
        String(this.Entry.Voucher_Distribution_Response_ID || "").trim()
      );
    },

    IsReReviewStatus() {
      return (
        String(this.Entry.Status || "").toUpperCase() === "RE_REVIEW" ||
        String(this.Entry.Current_Step || "").toUpperCase() === "RE_REVIEW" ||
        String(this.Entry.Progress_Step || "").toUpperCase() === "RE_REVIEW"
      );
    },

    IsSupervisor() {
      return ["MANAGER", "SUPERVISOR"].includes(
        String(this.oUser.Role || "")
          .trim()
          .toUpperCase(),
      );
    },

    IsManager() {
      return this.IsSupervisor;
    },

    CanTeleReviewEdit() {
      return this.CanEdit && !this.IsSupervisor;
    },

    IsCashoutEntry() {
      return this.Entry && this.Entry.IsCashout === true;
    },

    ShowVoucherPanel() {
      return (
        this.IsSupervisor &&
        [
          "APPROVED",
          "GET_VOUCHER",
          "VOUCHER_ISSUED",
          "SENT_VOUCHER",
          "SENT_ISSUED",
          "COMPLETED",
        ].includes(
          String(this.Entry.Status || "")
            .trim()
            .toUpperCase(),
        )
      );
    },

    ReviewActions() {
      return (this.AvailableActions || []).filter(
        (Action) =>
          !["GET_VOUCHER", "SEND_VOUCHER", "COMPLETE_CASHOUT"].includes(
            String((Action && Action.Code) || "")
              .trim()
              .toUpperCase(),
          ),
      );
    },

    VoucherActions() {
      if (!this.IsSupervisor) {
        return [];
      }

      return (this.AvailableActions || []).filter((Action) =>
        ["GET_VOUCHER", "SEND_VOUCHER", "COMPLETE_CASHOUT"].includes(
          String((Action && Action.Code) || "")
            .trim()
            .toUpperCase(),
        ),
      );
    },

    VoucherItems() {
      const iRequiredCount = Math.max(
        1,
        Math.min(
          2,
          Math.ceil(Number(this.Entry.Topup_Amount || 0) / 500000) || 1,
        ),
      );

      return [1, 2]
        .filter(
          (Index) =>
            Index <= iRequiredCount ||
            !!(
              this.Entry["Voucher_Code" + Index] ||
              this.Entry["Voucher_ID" + Index] ||
              this.Entry["Voucher_Status" + Index]
            ),
        )
        .map((Index) => {
          const RequestData = this.ParseJSONValue(
            this.Entry["Voucher_Request_Data" + Index],
          );

          const ResponseData = this.ParseJSONValue(
            this.Entry["Voucher_Response_Data" + Index],
          );

          return {
            Index: Index,
            ID: this.Entry["Voucher_ID" + Index] || "",
            Code: this.Entry["Voucher_Code" + Index] || "",
            RequestID: this.Entry["Voucher_Request_ID" + Index] || "",
            Status: this.Entry["Voucher_Status" + Index] || "",
            Expired: this.Entry["Voucher_Expiry_Date" + Index] || null,
            TakenAt:
              ResponseData.Reserved_At || RequestData.Reserved_At || null,
            RequestData: RequestData,
            ResponseData: ResponseData,
          };
        });
    },

    VoucherDistributionRequestData() {
      return this.ParseJSONValue(this.Entry.Voucher_Distribution_Request);
    },

    VoucherDistributionResponseData() {
      return this.ParseJSONValue(this.Entry.Voucher_Distribution_Response);
    },

    VoucherDistributionResponseTime() {
      const Data = this.VoucherDistributionResponseData || {};

      if (Data.Response_At) {
        return Data.Response_At;
      }

      /*
            Hỗ trợ record cũ từng lưu Date trực tiếp.
            */
      const LegacyValue = this.Entry.Voucher_Distribution_Response;

      if (LegacyValue && !Object.keys(Data).length) {
        const LegacyDate = new Date(LegacyValue);

        if (!Number.isNaN(LegacyDate.getTime())) {
          return LegacyValue;
        }
      }

      return this.Entry.Distributed_Time || null;
    },

    VoucherSendResponseText() {
      const Data = this.VoucherDistributionResponseData || {};

      if (!Object.keys(Data).length) {
        return "";
      }

      /*
            Voucher_Response_Data1/2 là response
            lúc lấy từng voucher.
            Response gửi Zalo chỉ đọc từ
            Voucher_Distribution_Response.
            */
      const DisplayData =
        Data.Result !== undefined
          ? Data.Result
          : Data.Error !== undefined
          ? Data.Error
          : Data;

      try {
        return JSON.stringify(DisplayData, null, 2);
      } catch (Error) {
        return String(DisplayData);
      }
    },

    CanEdit() {
      if (typeof this.Permissions.Can_Edit === "boolean") {
        return this.Permissions.Can_Edit;
      }

      return ["IN_REVIEW", "RE_REVIEW"].includes(this.Entry.Status);
    },

    IsDirty() {
      return JSON.stringify(this.Form) !== JSON.stringify(this.OriginalForm);
    },

    HasRegion() {
      return !!String(
        (this.Entry && this.Entry.Region) || ""
      ).trim();
    },

    OtherPresenceUsers() {
      const sUsername = this.oUser.Username || this.oUser.Usermame || "";

      return this.PresenceUsers.filter(
        (Item) => (Item.Username || Item.Usermame) !== sUsername,
      );
    },

    PresenceText() {
      const Names = this.OtherPresenceUsers.map(
        (Item) => Item.Full_Name || Item.Username || Item.Usermame,
      );

      if (Names.length <= 3) {
        return Names.join(", ");
      }

      return (
        Names.slice(0, 2).join(", ") + ` và ${Names.length - 2} người khác`
      );
    },
  },

  watch: {
    visible: {
      immediate: true,
      handler(Value) {
        if (Value && this.requestId) {
          this.LoadDetail();
        }
      },
    },

    requestId(NewValue, OldValue) {
      if (OldValue && OldValue !== NewValue) {
        CRMEntrySocket.LeaveEntry(OldValue);
      }

      if (this.visible && NewValue) {
        this.LoadDetail();
      }
    },
  },

  methods: {
    ...mapActions([
      "API_CRM_Entry_GetDetail",
      "API_CRM_Entry_GetLogs",
      "API_CRM_Entry_Update",
      "API_CRM_Entry_VerifyImage",
      "API_CRM_Entry_UploadImage",
      "API_CRM_Entry_Action",
    ]),

    async LoadDetail() {
      if (!this.requestId) {
        return;
      }

      this.IsLoading = true;
      this.HasRemoteChange = false;
      this.VoucherChecks = {
        1: null,
        2: null,
      };

      try {
        const Result = await this.API_CRM_Entry_GetDetail({
          Request_ID: this.requestId,
        });

        if (!Result || Result.State !== 1) {
          this.$message.error(
            Result && Result.Message ? Result.Message : "Không tải được Entry.",
          );

          this.Close();
          return;
        }

        const Data = Result.Data || {};

        this.Entry = Data.Entry || {};

        this.Customer = Data.Customer || null;

        this.Permissions = Data.Permissions || {};

        this.AvailableActions = Data.Available_Actions || [];

        this.Logs = Data.Logs || [];

        this.LogsPage = 1;

        this.HasMoreLogs = !!Data.HasMoreLogs;

        this.PresenceUsers = Data.Presence || [];

        this.SetFormFromEntry(this.Entry);

        CRMEntrySocket.JoinEntry(this.requestId);
      } catch (err) {
        this.$message.error("Không kết nối được máy chủ.");
      } finally {
        this.IsLoading = false;
      }
    },

    GetScratchStatusColor(Scratch_Status) {
      if (!Scratch_Status) return "#999";
      return this.Scratch_StatusColors[Scratch_Status.toUpperCase()] || "#999";
    },
    GetScratchStatusLabel(Scratch_Status) {
      if (!Scratch_Status) return "#999";
      return (
        this.Scratch_StatusLabels[Scratch_Status.toUpperCase()] ||
        Scratch_Status ||
        "-"
      );
    },
    SetFormFromEntry(Entry) {
      const Form = {
        Full_Name: Entry.Full_Name || "",

        CCCD: Entry.CCCD || "",

        Address: Entry.Address || "",

        DoB: this.ToDateInput(Entry.DoB),

        Gender: Entry.Gender || "",

        Region: Entry.Region || "",

        Note: Entry.Note || "",

        IsCashout: Entry.IsCashout === true,

        Scratch_Code_Image_Note: Entry.Scratch_Code_Image_Note || "",

        CCCD_Image_Note: Entry.CCCD_Image_Note || "",

        SuperVisor_Comment: Entry.SuperVisor_Comment || "",
      };

      this.Form = {
        ...Form,
      };

      this.OriginalForm = {
        ...Form,
      };

      this.ResetSyncedFields();
    },

    ResetSyncedFields() {
      this.SyncedFields = {
        Full_Name: false,
        CCCD: false,
        Address: false,
        DoB: false,
        Gender: false,
      };
    },

    ApplyCustomerProfile() {
      if (!this.Customer) {
        return;
      }

      const Fields = ["Full_Name", "CCCD", "Address", "Gender"];

      Fields.forEach((Field) => {
        if (
          this.Customer[Field] !== undefined &&
          this.Customer[Field] !== null &&
          this.Customer[Field] !== ""
        ) {
          this.$set(this.Form, Field, this.Customer[Field]);

          this.$set(this.SyncedFields, Field, true);
        }
      });

      if (this.Customer.DoB) {
        this.$set(this.Form, "DoB", this.ToDateInput(this.Customer.DoB));

        this.$set(this.SyncedFields, "DoB", true);
      }

      this.$message.success(
        "Đã áp dụng hồ sơ Customer vào Entry. Bấm Lưu thay đổi để ghi nhận.",
      );
    },

    BuildChangedFields() {
      const Changes = {};

      EDITABLE_FIELDS.forEach((Field) => {
        const OldValue = this.OriginalForm[Field];

        const NewValue = this.Form[Field];

        if (JSON.stringify(OldValue) !== JSON.stringify(NewValue)) {
          Changes[Field] = NewValue;
        }
      });

      return Changes;
    },

    async SaveEntry() {
      const Changes = this.BuildChangedFields();

      if (Object.keys(Changes).length === 0) {
        return;
      }

      this.IsSaving = true;

      try {
        const Result = await this.API_CRM_Entry_Update({
          Request_ID: this.requestId,

          Changes,
        });

        if (!Result || Result.State !== 1) {
          this.$message.error(
            Result && Result.Message ? Result.Message : "Không lưu được Entry.",
          );

          return;
        }

        const Data = Result.Data || {};

        if (Data.Entry) {
          this.Entry = {
            ...this.Entry,
            ...Data.Entry,
          };
        } else {
          this.Entry = {
            ...this.Entry,
            ...Changes,
          };
        }

        if (Data.Customer) {
          this.Customer = Data.Customer;
        }

        if (Data.Log) {
          this.PrependLog(Data.Log);
        }

        this.SetFormFromEntry(this.Entry);

        this.HasRemoteChange = false;

        this.$emit("entry-updated", this.Entry);

        this.$message.success(Result.Message || "Đã lưu thay đổi.");
      } catch (err) {
        this.$message.error("Không kết nối được máy chủ.");
      } finally {
        this.IsSaving = false;
      }
    },

    async VerifyImage(ImageType) {
      this.VerifyLoading = ImageType;

      try {
        const Result = await this.API_CRM_Entry_VerifyImage({
          Request_ID: this.requestId,

          Image_Type: ImageType,

          Note:
            ImageType === "SCRATCH_CODE"
              ? this.Form.Scratch_Code_Image_Note
              : this.Form.CCCD_Image_Note,
        });

        if (!Result || Result.State !== 1) {
          this.$message.error(
            Result && Result.Message
              ? Result.Message
              : "Không xác nhận được hình ảnh.",
          );

          return;
        }

        this.ApplyAPIResult(Result.Data);

        this.$message.success(Result.Message || "Đã xác nhận hình ảnh.");
      } finally {
        this.VerifyLoading = "";
      }
    },

    async OnFileSelected(ImageType, Event) {
      const Input = Event.target;
      const File = Input.files && Input.files[0];

      Input.value = "";

      if (!File) {
        return;
      }

      const FormDataValue = new FormData();

      FormDataValue.append("Request_ID", this.requestId);

      FormDataValue.append("Image_Type", ImageType);

      FormDataValue.append("Image", File);

      this.UploadLoading = ImageType;

      try {
        const Result = await this.API_CRM_Entry_UploadImage(FormDataValue);

        if (!Result || Result.State !== 1) {
          this.$message.error(
            Result && Result.Message
              ? Result.Message
              : "Không upload được hình ảnh.",
          );

          return;
        }

        this.ApplyAPIResult(Result.Data);

        this.$message.success(
          Result.Message || "Đã upload và xác nhận hình ảnh.",
        );
      } finally {
        this.UploadLoading = "";
      }
    },

    ParseJSONValue(Value) {
      if (!Value) {
        return {};
      }

      if (typeof Value === "object" && !Array.isArray(Value)) {
        return Value;
      }

      try {
        const Result = JSON.parse(Value);
        return Result && typeof Result === "object" ? Result : {};
      } catch (Error) {
        return {};
      }
    },

    GetVoucherDLRStatusLabel(Status) {
      const Key = String(Status || "")
        .trim()
        .toUpperCase();

      const Labels = {
        WAITING_DLR: "Đang chờ ZNS xác nhận gửi",
        DELIVERED: "Voucher đã gửi đến khách hàng",
        FAILED: "ZNS xác nhận gửi thất bại",
      };

      if (!Key && this.Entry.Voucher_Distribution_Response_ID) {
        return "Đã gửi sang ZNS, chưa có trạng thái DLR";
      }

      return Labels[Key] || Key || "Chưa có trạng thái DLR";
    },

    GetVoucherDLRAlertType(Status) {
      const Key = String(Status || "")
        .trim()
        .toUpperCase();

      if (
        Key === "DELIVERED" ||
        this.Entry.IsDistributed === true
      ) {
        return "success";
      }

      if (Key === "FAILED") {
        return "error";
      }

      return "info";
    },

    GetVoucherDLRDescription() {
      const Note = String(
        this.Entry.Voucher_Distribution_DLR_Note || "",
      ).trim();

      if (Note) {
        return Note;
      }

      const Key = String(
        this.Entry.Voucher_Distribution_DLR_Status || "",
      )
        .trim()
        .toUpperCase();

      if (
        Key === "DELIVERED" ||
        this.Entry.IsDistributed === true
      ) {
        return "Đã nhận xác nhận voucher được gửi thành công đến khách hàng.";
      }

      if (Key === "FAILED") {
        const ErrorCode = String(
          this.Entry.Voucher_Distribution_DLR_Error_Code || "",
        ).trim();

        return ErrorCode
          ? "Mã lỗi ZNS: " + ErrorCode
          : "Nhà cung cấp xác nhận gửi voucher thất bại.";
      }

      return "Yêu cầu đã được gửi sang đài và đang chờ kết quả Delivery.";
    },

    GetVoucherDLRSourceLabel(Source) {
      const Key = String(Source || "")
        .trim()
        .toUpperCase();

      const Labels = {
        CALLBACK: "DLR Callback",
        TIMELINE_RECONCILE: "Zenify Timeline Reconcile",
      };

      return Labels[Key] || Source || "-";
    },

    GetVoucherStageColor(Status) {
      const Colors = {
        FAILED: "volcano",
        RESERVED: "blue",
        SENDING: "cyan",
        SEND_FAILED: "magenta",
        SEND_RESULT_UNKNOWN: "orange",
        DISTRIBUTED: "green",
      };

      return (
        Colors[
          String(Status || "")
            .trim()
            .toUpperCase()
        ] || "default"
      );
    },

    GetVoucherStageLabel(Status) {
      const Labels = {
        FAILED: "Lấy thất bại",
        RESERVED: "Đã lấy",
        SENDING: "Đang gửi",
        SEND_FAILED: "Gửi thất bại",
        SEND_RESULT_UNKNOWN: "Chưa rõ kết quả gửi",
        DISTRIBUTED: "Đã gửi thành công",
      };

      const Key = String(Status || "")
        .trim()
        .toUpperCase();

      return Labels[Key] || Status || "Chưa có";
    },

    GetVoucherCheckMessage(Result) {
      if (!Result) {
        return "";
      }

      const OtherRequestIDs = Result.Other_Request_IDs || [];

      if (!OtherRequestIDs.length) {
        return (
          "Mã chỉ đang được sử dụng bởi Entry #" +
          (Result.Current_Request_ID || this.requestId) +
          "."
        );
      }

      return "Mã còn xuất hiện ở Request ID: " + OtherRequestIDs.join(", ");
    },

    async CheckVoucherCount() {
      this.VoucherCountCheckLoading = true;

      try {
        const Result = await this.API_CRM_Entry_Action({
          Request_ID: this.requestId,

          Action: "CHECK_VOUCHER_COUNT",
        });

        if (!Result || Result.State !== 1) {
          this.$message.error(
            Result && Result.Message
              ? Result.Message
              : "Không kiểm tra được số lượng voucher.",
          );

          return;
        }

        const CheckResult =
          Result.Data && Result.Data.Voucher_Count_Check
            ? Result.Data.Voucher_Count_Check
            : null;

        if (!CheckResult || CheckResult.Is_Valid !== true) {
          const iActualCount = CheckResult
            ? Number(CheckResult.Actual_Count || 0)
            : 0;

          /*
                    duration = 0:
                    message đỏ giữ nguyên đến khi người dùng đóng.
                    */
          this.$message.error(
            "Request ID #" +
              this.requestId +
              " phải có đúng 2 voucher, " +
              "hiện đang có " +
              iActualCount +
              " voucher.",
            0,
          );

          return;
        }

        this.$message.success(
          "Request ID #" + this.requestId + " đang có đúng 2 voucher.",
        );
      } catch (Error) {
        console.log("CRM-CheckVoucherCount-Error:", Error);

        this.$message.error(
          Error && Error.message
            ? Error.message
            : "Không kiểm tra được số lượng voucher.",
        );
      } finally {
        this.VoucherCountCheckLoading = false;
      }
    },

    async CheckVoucherUsage(VoucherIndex) {
      this.VoucherCheckLoading = VoucherIndex;

      try {
        const Result = await this.API_CRM_Entry_Action({
          Request_ID: this.requestId,
          Action: "CHECK_VOUCHER_CODE",
          Voucher_Index: VoucherIndex,
        });

        if (!Result || Result.State !== 1) {
          this.$message.error(
            Result && Result.Message
              ? Result.Message
              : "Không kiểm tra được mã voucher.",
          );
          return;
        }

        const CheckResult =
          Result.Data && Result.Data.Voucher_Check
            ? Result.Data.Voucher_Check
            : null;

        this.$set(this.VoucherChecks, VoucherIndex, CheckResult);

        if (CheckResult && CheckResult.Has_Conflict) {
          this.$message.warning(Result.Message);
        } else {
          this.$message.success(Result.Message);
        }
      } finally {
        this.VoucherCheckLoading = "";
      }
    },

    async RunAction(Action) {
      if (!Action || !Action.Code) {
        return;
      }

      this.ActionLoading = Action.Code;

      try {
        const Result = await this.API_CRM_Entry_Action({
          Request_ID: this.requestId,

          Action: Action.Code,

          SuperVisor_Comment: this.IsSupervisor
            ? String(this.Form.SuperVisor_Comment || "").trim()
            : "",

          Changes: this.BuildChangedFields(),
        });
        console.log("CRM Entry Action Result:", Result);
        if (!Result || Result.State !== 1) {
          this.$message.error(
            Result && Result.Message
              ? Result.Message
              : "Không thực hiện được thao tác.",
          );

          return;
        }

        this.ApplyAPIResult(Result.Data);

        this.$message.success(Result.Message || "Thao tác thành công.");
      } finally {
        this.ActionLoading = "";
      }
    },

    ApplyAPIResult(Data) {
      if (!Data) {
        return;
      }

      if (Data.Entry) {
        this.Entry = {
          ...this.Entry,
          ...Data.Entry,
        };

        this.SetFormFromEntry(this.Entry);

        this.$emit("entry-updated", this.Entry);
      }

      if (Data.Customer) {
        this.Customer = Data.Customer;
      }

      if (Data.Log) {
        this.PrependLog(Data.Log);
      }

      if (Data.Permissions) {
        this.Permissions = Data.Permissions;
      }

      if (Data.Available_Actions !== undefined) {
        this.AvailableActions = Data.Available_Actions || [];
      }
    },

    ApplySocketEntry(Payload) {
      const SocketEntry = Payload.Entry || Payload;

      if (!SocketEntry || SocketEntry.Request_ID !== this.requestId) {
        return;
      }

      const PreviousEntry = {
        ...this.Entry,
      };

      this.Entry = {
        ...this.Entry,
        ...SocketEntry,
      };

      this.AppendVoucherDLRSocketLog(
        PreviousEntry,
        this.Entry,
        Payload,
      );

      if (!this.IsDirty) {
        this.SetFormFromEntry(this.Entry);
      } else {
        this.HasRemoteChange = true;
      }

      if (Payload.Customer) {
        this.Customer = Payload.Customer;
      }

      if (Payload.Permissions) {
        this.Permissions = Payload.Permissions;
      }

      if (Payload.Available_Actions !== undefined) {
        this.AvailableActions = Payload.Available_Actions || [];
      }

      this.$emit("entry-updated", this.Entry);
    },

    AppendVoucherDLRSocketLog(PreviousEntry, CurrentEntry, Payload) {
      const OldStatus = String(
        PreviousEntry.Voucher_Distribution_DLR_Status || "",
      ).trim().toUpperCase();

      const NewStatus = String(
        CurrentEntry.Voucher_Distribution_DLR_Status || "",
      ).trim().toUpperCase();

      const OldDistributed =
        PreviousEntry.IsDistributed === true;

      const NewDistributed =
        CurrentEntry.IsDistributed === true;

      if (
        OldStatus === NewStatus &&
        OldDistributed === NewDistributed
      ) {
        return;
      }

      if (!NewStatus && !NewDistributed) {
        return;
      }

      const EventCode =
        NewStatus === "DELIVERED" || NewDistributed
          ? "DLR_DELIVERED"
          : NewStatus === "FAILED"
            ? "DLR_FAILED"
            : "DLR_WAITING";

      const Changes = {};

      if (OldStatus !== NewStatus) {
        Changes.Voucher_Distribution_DLR_Status = {
          Old: OldStatus || "",
          New: NewStatus || "",
        };
      }

      if (OldDistributed !== NewDistributed) {
        Changes.IsDistributed = {
          Old: OldDistributed,
          New: NewDistributed,
        };
      }

      if (
        CurrentEntry.Voucher_Distribution_DLR_Note &&
        CurrentEntry.Voucher_Distribution_DLR_Note !==
          PreviousEntry.Voucher_Distribution_DLR_Note
      ) {
        Changes.Voucher_Distribution_DLR_Note = {
          Old:
            PreviousEntry.Voucher_Distribution_DLR_Note || "",
          New:
            CurrentEntry.Voucher_Distribution_DLR_Note || "",
        };
      }

      const LogTime =
        CurrentEntry.Voucher_Distribution_DLR_Updated_At ||
        CurrentEntry.Distributed_Time ||
        new Date().toISOString();

      this.PrependLog({
        _id:
          "SOCKET_DLR_" +
          CurrentEntry.Request_ID +
          "_" +
          EventCode +
          "_" +
          String(LogTime),
        Request_ID: CurrentEntry.Request_ID,
        Usermame: "Hệ thống ZNS",
        Modified_Short_Code: EventCode,
        Created_At: LogTime,
        Message:
          CurrentEntry.Voucher_Distribution_DLR_Note ||
          (Payload.Voucher_Error &&
            Payload.Voucher_Error.Message) ||
          "",
        Changes,
      });
    },

    ApplySocketLog(Payload) {
      const Log = Payload.Log || Payload;

      if (!Log || Log.Request_ID !== this.requestId) {
        return;
      }

      this.PrependLog(Log);
    },

    ApplySocketPresence(Payload) {
      if (!Payload || Payload.Request_ID !== this.requestId) {
        return;
      }

      this.PresenceUsers = Payload.Users || [];
    },

    PrependLog(Log) {
      if (!Log) {
        return;
      }

      const sLogID =
        Log._id ||
        [
          Log.Request_ID,
          Log.Usermame,
          Log.Created_At,
          Log.Modified_Short_Code,
        ].join("|");

      const IsExists = this.Logs.some((Item) => {
        const sItemID =
          Item._id ||
          [
            Item.Request_ID,
            Item.Usermame,
            Item.Created_At,
            Item.Modified_Short_Code,
          ].join("|");

        return sItemID === sLogID;
      });

      if (!IsExists) {
        this.Logs.unshift(Log);
      }
    },

    async LoadMoreLogs() {
      if (this.IsLoadingLogs || !this.HasMoreLogs) {
        return;
      }

      this.IsLoadingLogs = true;

      try {
        const NextPage = this.LogsPage + 1;

        const Result = await this.API_CRM_Entry_GetLogs({
          Request_ID: this.requestId,

          Page: NextPage,
          PageSize: this.LogsPageSize,
        });

        if (!Result || Result.State !== 1) {
          return;
        }

        const Data = Result.Data || {};
        const MoreLogs = Data.Logs || [];

        this.Logs.push(...MoreLogs);
        this.LogsPage = NextPage;
        this.HasMoreLogs = !!Data.HasMore;
      } finally {
        this.IsLoadingLogs = false;
      }
    },

    OpenImagePreview(Title, Path) {
      if (!Path) {
        return;
      }

      this.ImagePreview = {
        Visible: true,
        Title: Title || "Xem ảnh",
        Path: Path,
        Left: 0,

        Zoom: 1,
        OriginX: 50,
        OriginY: 50,
        Rotation: 0,

        PanX: 0,
        PanY: 0,
        Dragging: false,
        DragMoved: false,
        DragStartX: 0,
        DragStartY: 0,
        PanStartX: 0,
        PanStartY: 0,
      };

      /*
       * image-panel nằm bên trong entry-detail-main,
       * còn preview nằm trên entry-detail-layout.
       *
       * Đo vị trí thực tế để preview bắt đầu chính xác
       * từ mép trái image-panel rồi phủ tới hết Log.
       */
      this.$nextTick(() => {
        this.UpdateImagePreviewPosition();
      });
    },

    SetPreviewZoomOrigin(Event) {
      const Image = this.$refs.PreviewImage;

      if (!Image || !Event) {
        return;
      }

      const Rect = Image.getBoundingClientRect();

      if (!Rect.width || !Rect.height) {
        return;
      }

      const OriginX = ((Event.clientX - Rect.left) / Rect.width) * 100;

      const OriginY = ((Event.clientY - Rect.top) / Rect.height) * 100;

      this.ImagePreview.OriginX = Math.max(0, Math.min(100, OriginX));

      this.ImagePreview.OriginY = Math.max(0, Math.min(100, OriginY));
    },

    ZoomPreviewImage(Event) {
      if (!this.ImagePreview.Path) {
        return;
      }

      this.SetPreviewZoomOrigin(Event);

      const Step = Event.deltaY < 0 ? 0.25 : -0.25;

      const Zoom = this.ImagePreview.Zoom + Step;

      this.ImagePreview.Zoom = Math.max(
        1,
        Math.min(5, Number(Zoom.toFixed(2))),
      );

      if (this.ImagePreview.Zoom === 1) {
        this.ResetPreviewPan();
      }
    },

    TogglePreviewZoom(Event) {
      if (!this.ImagePreview.Path) {
        return;
      }

      /*
       * Sau khi kéo ảnh browser vẫn phát click.
       * Chặn click đó để không vô tình zoom-out.
       */
      if (this.ImagePreview.DragMoved) {
        this.ImagePreview.DragMoved = false;
        return;
      }

      this.SetPreviewZoomOrigin(Event);

      this.ImagePreview.Zoom = this.ImagePreview.Zoom === 1 ? 2 : 1;

      if (this.ImagePreview.Zoom === 1) {
        this.ResetPreviewPan();
      }
    },

    ResetPreviewPan() {
      this.ImagePreview.PanX = 0;
      this.ImagePreview.PanY = 0;
      this.ImagePreview.Dragging = false;
      this.ImagePreview.DragMoved = false;
    },

    StartPreviewDrag(Event) {
      if (
        !this.ImagePreview.Path ||
        this.ImagePreview.Zoom <= 1
      ) {
        return;
      }

      this.ImagePreview.Dragging = true;
      this.ImagePreview.DragMoved = false;

      this.ImagePreview.DragStartX = Event.clientX;
      this.ImagePreview.DragStartY = Event.clientY;

      this.ImagePreview.PanStartX =
        Number(this.ImagePreview.PanX || 0);

      this.ImagePreview.PanStartY =
        Number(this.ImagePreview.PanY || 0);
    },

    MovePreviewDrag(Event) {
      if (!this.ImagePreview.Dragging) {
        return;
      }

      const DeltaX =
        Event.clientX -
        this.ImagePreview.DragStartX;

      const DeltaY =
        Event.clientY -
        this.ImagePreview.DragStartY;

      if (
        Math.abs(DeltaX) > 2 ||
        Math.abs(DeltaY) > 2
      ) {
        this.ImagePreview.DragMoved = true;
      }

      this.ImagePreview.PanX =
        this.ImagePreview.PanStartX +
        DeltaX;

      this.ImagePreview.PanY =
        this.ImagePreview.PanStartY +
        DeltaY;
    },

    EndPreviewDrag() {
      this.ImagePreview.Dragging = false;
    },

    RotatePreviewImage(Degree) {
      if (!this.ImagePreview.Path) {
        return;
      }

      /*
       * Không normalize góc.
       * Như vậy transition luôn chạy đúng chiều bấm:
       * trái: 0 -> -90 -> -180...
       * phải: 0 -> 90 -> 180...
       */
      this.ImagePreview.Rotation +=
        Number(Degree || 0);
    },

    UpdateImagePreviewPosition() {
      const Layout = this.$refs.DetailLayout;

      const ImagePanel = this.$refs.ImagePanel;

      if (!Layout || !ImagePanel) {
        return;
      }

      const LayoutRect = Layout.getBoundingClientRect();

      const ImageRect = ImagePanel.getBoundingClientRect();

      this.ImagePreview.Left = Math.max(
        0,
        Math.round(ImageRect.left - LayoutRect.left),
      );
    },

    CloseImagePreview() {
      this.ImagePreview = {
        Visible: false,
        Title: "",
        Path: "",
        Left: 0,

        Zoom: 1,
        OriginX: 50,
        OriginY: 50,
        Rotation: 0,

        PanX: 0,
        PanY: 0,
        Dragging: false,
        DragMoved: false,
        DragStartX: 0,
        DragStartY: 0,
        PanStartX: 0,
        PanStartY: 0,
      };
    },

    Close() {
      this.CloseImagePreview();

      CRMEntrySocket.LeaveEntry(this.requestId);

      this.$emit("close");
    },

    ResolveImage(Value) {
      if (!Value) {
        return "";
      }

      let ImagePath = String(Value).trim();

      /*
       * URL ngoài hệ thống:
       * giữ nguyên, không gắn CRM token.
       */
      if (/^https?:\/\//i.test(ImagePath)) {
        return ImagePath;
      }

      /*
       * Tương thích dữ liệu cũ từng lưu:
       * /upload/awards/...
       *
       * Chuẩn hiện tại:
       * /uploads/awards/...
       */
      if (ImagePath.startsWith("/upload/awards/")) {
        ImagePath =
          "/uploads/awards/" + ImagePath.substring("/upload/awards/".length);
      }

      if (!ImagePath.startsWith("/")) {
        ImagePath = "/" + ImagePath;
      }

      const ImageURL = this.$PRJ_DOMAIN + ImagePath;

      /*
       * Chỉ ảnh nằm trong vùng Nginx bảo vệ
       * mới cần CRM token.
       *
       * Customer/Entry đều có thể dùng:
       * - /uploads/awards/...
       * - /uploads/crm/...
       */
      const IsProtectedUpload =
        ImagePath.startsWith("/uploads/awards/") ||
        ImagePath.startsWith("/uploads/crm/");

      if (!IsProtectedUpload) {
        return ImageURL;
      }

      const Token =
        this.oUser && this.oUser.Token ? String(this.oUser.Token).trim() : "";

      if (!Token) {
        return ImageURL;
      }

      return (
        ImageURL +
        (ImageURL.includes("?") ? "&" : "?") +
        "token=" +
        encodeURIComponent(Token)
      );
    },

    ToDateInput(Value) {
      if (!Value) {
        return "";
      }

      const DateValue = new Date(Value);

      if (Number.isNaN(DateValue.getTime())) {
        return "";
      }

      const Year = DateValue.getFullYear();

      const Month = String(DateValue.getMonth() + 1).padStart(2, "0");

      const Day = String(DateValue.getDate()).padStart(2, "0");

      return `${Year}-${Month}-${Day}`;
    },

    FormatDate(Value) {
      if (!Value) {
        return "-";
      }
      return moment.utc(Value).format("DD/MM/YYYY")
      // return new Date(Value).toLocaleDateString("vi-VN");
    },

    FormatDateTime(Value) {
      if (!Value) {
        return "-";
      }

      return new Date(Value).toLocaleString("vi-VN");
    },

    FormatMoney(Value) {
      const NumberValue = Number(Value || 0);

      if (!NumberValue) {
        return "-";
      }

      return NumberValue.toLocaleString("vi-VN");
    },

    GetStatusColor(Status) {
      const Colors = {
        IN_REVIEW: "blue",
        PENDING: "gold",
        VERIFIED: "cyan",
        RE_REVIEW: "orange",
        APPROVED: "purple",
        GET_VOUCHER: "geekblue",
        VOUCHER_ISSUED: "volcano",
        SENT_VOUCHER: "blue",
        SENT_ISSUED: "magenta",
        COMPLETED: "green",
        REJECTED: "red",
      };

      return Colors[Status] || "default";
    },
  },
};
</script>

<style scoped>
.entry-detail-spin {
  height: 100%;
}

.entry-detail-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  height: 100%;
  overflow: hidden;
}

.entry-detail-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: #f5f5f5;
}

.entry-detail-scroll {
  /* flex: 1; */
  min-height: 0;
  padding: 8px 8px 4px;
  overflow-y: auto;
}

.entry-drawer-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: 26px;
  gap: 14px;
  flex-wrap: wrap;
}

.entry-drawer-title span:not(:last-child)::after {
  content: "|";
  margin-left: 8px;
  /* khoảng cách từ text đến | */
  color: #999;
  /* màu dấu | */
}

.entry-presence {
  display: flex;
  align-items: center;
  color: #1677ff;
  font-size: 13px;
  font-weight: normal;
}

.presence-dot {
  width: 7px;
  height: 7px;
  margin-right: 6px;
  border-radius: 50%;
  background: #1677ff;
  animation: presence-blink 1.3s infinite;
}

@keyframes presence-blink {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }
}

.remote-update-alert {
  margin-bottom: 12px;
}

.entry-status-header {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 12px 16px;
  margin-bottom: 12px;
  background: #fff;
  border-radius: 4px;
}

.status-label {
  margin-right: 5px;
  color: rgba(0, 0, 0, 0.45);
}

.entry-section-card {
  margin-bottom: 5px;
}

.entry-info-card ::v-deep .ant-card-body {
  padding-bottom: 6px;
}

.entry-profile-title {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 6px 0 2px;
  font-weight: 600;
}

.entry-profile-note {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  font-weight: normal;
}

.entry-profile-form ::v-deep .ant-form-item {
  margin-bottom: 4px;
}

.entry-profile-form ::v-deep .ant-form-item-label {
  padding-bottom: 2px;
  line-height: 1.2;
}

.image-review-title {
  margin-bottom: 5px;
  font-weight: 600;
}

.image-compare-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px;
}

.image-box {
  min-height: 132px;
  padding: 4px;
  text-align: center;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}

.image-box img {
  width: 100%;
  height: 102px;
  object-fit: contain;
}

.image-label {
  margin-bottom: 6px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}

.image-status-row {
  display: flex;
  align-items: center;
  min-height: 28px;
  margin-top: 5px;
}

.image-action-row {
  display: flex;
  gap: 6px;
  margin-top: 6px;
}

.hidden-upload-input {
  display: none;
}

.customer-synced-field {
  padding: 8px 10px 2px;
  background: #e6f4ff;
  border-left: 3px solid #1677ff;
  border-radius: 3px;
}

.entry-action-footer {
  position: relative;
  z-index: 10;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 7px 10px;
  background: #fff;
  border-top: 1px solid #d9d9d9;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
}

.business-action-list {
  display: flex;
  gap: 4px;
}

.entry-action-footer ::v-deep .ant-btn {
  height: 32px;
  padding: 0 11px;
}

.business-action-list {
  flex-wrap: wrap;
  justify-content: flex-end;
}

.entry-detail-scroll ::v-deep .ant-card-head {
  min-height: 34px;
  padding: 0 10px;
}

.entry-detail-scroll ::v-deep .ant-card-head-title {
  padding: 7px 0;
}

.entry-detail-scroll ::v-deep .ant-card-extra {
  padding: 5px 0;
}

.entry-detail-scroll ::v-deep .ant-card-body {
  padding: 9px 10px;
}

.entry-detail-scroll
  ::v-deep
  .ant-descriptions-small
  .ant-descriptions-item-label,
.entry-detail-scroll
  ::v-deep
  .ant-descriptions-small
  .ant-descriptions-item-content {
  padding: 5px 8px;
}

.dense-entry-layout {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.voucher-supervisor-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
  padding: 10px;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}

.voucher-panel-header,
.voucher-info-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.voucher-panel-title,
.voucher-panel-header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.voucher-panel-header-actions {
  justify-content: flex-end;
  flex-wrap: wrap;
}

.voucher-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.voucher-info-card {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 6px;
  padding: 8px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}

.voucher-info-row {
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  min-height: 24px;
  font-size: 12px;
}

.voucher-info-row > span,
.voucher-send-summary span {
  color: rgba(0, 0, 0, 0.45);
}

.voucher-info-row code,
.voucher-info-row strong {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.voucher-send-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
}

.voucher-send-summary > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
  padding: 7px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 3px;
}

.voucher-zalo-response {
  overflow: hidden;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
}

.voucher-response-title {
  padding: 5px 8px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  font-size: 12px;
  font-weight: 600;
}

.voucher-zalo-response pre {
  max-height: 220px;
  margin: 0;
  padding: 8px;
  overflow: auto;
  font-size: 11px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
}

.voucher-action-list {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

@media (max-width: 1100px) {
  .voucher-panel-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .voucher-panel-header-actions {
    width: 100%;
    justify-content: space-between;
  }

  .voucher-info-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .voucher-send-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.entry-summary-strip {
  display: grid;
  grid-template-columns:
    minmax(86px, 0.8fr) minmax(100px, 0.9fr) minmax(80px, 0.7fr)
    minmax(88px, 0.75fr) minmax(74px, 0.65fr) minmax(94px, 0.8fr) minmax(150px, 1.25fr);
  overflow: hidden;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 3px;
}

.summary-cell {
  display: flex;
  min-width: 0;
  min-height: 50px;
  flex-direction: column;
  justify-content: center;
  padding: 4px 8px;
  border-right: 1px solid #f0f0f0;
}

.summary-cell:last-child {
  border-right: 0;
}

.summary-label {
  overflow: hidden;
  margin-bottom: 1px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 10px;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

.summary-cell strong {
  overflow: hidden;
  font-size: 12px;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.summary-tag {
  width: max-content;
  max-width: 100%;
  margin: 0;
  overflow: hidden;
  line-height: 18px;
  text-overflow: ellipsis;
}

.customer-reference-bar {
  display: flex;
  align-items: center;
  min-height: 50px;
  gap: 10px;
  padding: 3px 7px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 3px;
  font-size: 12px;
}

.customer-reference-title {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
  padding-right: 8px;
  border-right: 1px solid #e8e8e8;
}

.customer-reference-item {
  flex: 0 0 auto;
  white-space: nowrap;
}

.customer-reference-address {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.muted-text {
  color: rgba(0, 0, 0, 0.45);
}

.dense-workspace {
  display: grid;
  grid-template-columns: minmax(300px, 30%) minmax(0, 70%);
  min-height: 0;
  align-items: start;
  gap: 4px;
}

.dense-panel {
  min-width: 0;
  padding: 7px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 3px;
}

.dense-panel-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 23px;
  margin-bottom: 5px;
  padding-bottom: 4px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 12px;
  font-weight: 600;
}

.dense-panel-title span {
  display: flex;
  align-items: center;
  gap: 5px;
}

.dense-panel-title small {
  color: rgba(0, 0, 0, 0.45);
  font-size: 10px;
  font-weight: normal;
}

.dense-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 8px;
}

.dense-field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
  margin: 0;
}

.dense-field > span {
  color: rgba(0, 0, 0, 0.55);
  font-size: 10px;
  line-height: 1.1;
}

.dense-field--address,
.dense-field--note,
.dense-field--cashout {
  grid-column: span 2;
}

.dense-field--cashout .ant-radio-group {
  display: flex;
  width: 100%;
}

.dense-field--cashout .ant-radio-button-wrapper {
  flex: 1;
  height: 28px;
  padding: 0 8px;
  overflow: hidden;
  font-size: 11px;
  line-height: 26px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dense-form ::v-deep .ant-input,
.dense-form ::v-deep .ant-select-selection {
  height: 26px;
  font-size: 12px;
}

.dense-form ::v-deep .ant-select-selection__rendered {
  line-height: 24px;
}

.supervisor-inline {
  display: grid;
  grid-template-columns: 1fr;
  margin-top: 6px;
  overflow: hidden;
  border: 1px solid #f0f0f0;
  border-radius: 3px;
  font-size: 12px;
}

.supervisor-inline__head {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  padding: 5px 7px;
  background: #fafafa;
}

.supervisor-inline__head span {
  overflow: hidden;
  color: rgba(0, 0, 0, 0.55);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.supervisor-inline__comment {
  min-width: 0;
  padding: 5px 7px;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.65);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.compact-image-groups {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
}

.compact-image-group {
  min-width: 0;
  padding: 7px;
  border: 1px solid #f0f0f0;
  border-radius: 3px;
}

.compact-image-group__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 22px;
  margin-bottom: 4px;
  font-size: 12px;
}

.compact-image-group__head .ant-tag {
  margin-right: 0;
  padding: 0 5px;
  font-size: 10px;
  line-height: 18px;
}

.compact-thumbnails {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  margin-bottom: 6px;
}

.compact-thumb {
  position: relative;
  height: 190px;
  overflow: hidden;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
}

.compact-thumb > span {
  position: absolute;
  z-index: 1;
  top: 2px;
  left: 3px;
  padding: 0 3px;
  background: rgba(255, 255, 255, 0.88);
  color: rgba(0, 0, 0, 0.55);
  font-size: 9px;
  line-height: 15px;
  border-radius: 2px;
}

.compact-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.compact-image-group > .ant-input {
  height: 25px;
  font-size: 12px;
}

.compact-image-actions {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 4px;
}

.compact-image-actions .ant-btn {
  height: 25px;
  padding: 0 7px;
  font-size: 12px;
}

@media (max-width: 1366px) {
  .entry-detail-layout {
    grid-template-columns: minmax(0, 1fr) 320px;
  }
}

@media (max-width: 1380px) {
  .entry-summary-strip {
    grid-template-columns: repeat(4, minmax(100px, 1fr));
  }

  .summary-cell {
    border-bottom: 1px solid #f0f0f0;
  }

  .dense-workspace {
    grid-template-columns: minmax(300px, 30%) minmax(0, 70%);
  }

  .compact-thumb {
    height: 160px;
  }
}

@media (max-width: 1050px) {
  .dense-workspace {
    grid-template-columns: 1fr;
  }

  .compact-thumb {
    height: 190px;
  }
}

@media (max-width: 760px) {
  .customer-reference-bar {
    flex-wrap: wrap;
    overflow: visible;
  }

  .customer-reference-address {
    flex-basis: 100%;
  }

  .dense-form-grid {
    grid-template-columns: 1fr 1fr;
  }

  .dense-field--address,
  .dense-field--note {
    grid-column: span 2;
  }

  .compact-image-groups {
    grid-template-columns: 1fr;
  }

  .supervisor-inline {
    grid-template-columns: 1fr;
  }
}

/* ===== RIGHT IMAGE PREVIEW ===== */

.compact-thumb--clickable {
  cursor: zoom-in;
}

.compact-thumb--clickable:hover {
  border-color: #1890ff;
  box-shadow: 0 0 0 1px rgba(24, 144, 255, 0.12);
}

/*
 * entry-detail-layout là mốc tọa độ của preview.
 * Grid gốc Main + Log được giữ nguyên hoàn toàn.
 */
.entry-detail-layout {
  position: relative;
}

/*
 * Left được tính runtime từ đúng mép trái .image-panel.
 * right: 0 => phủ luôn toàn bộ Log panel.
 */
.entry-image-preview-panel {
  position: absolute;
  z-index: 80;
  right: 0;
  top: 67px;
  bottom: 47px;

  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;

  min-width: 0;
  min-height: 0;
  overflow: hidden;

  background: #111;
  border-left: 1px solid #d9d9d9;

  box-shadow: -4px 0 14px rgba(0, 0, 0, 0.14);
}

.entry-image-preview-head {
  display: flex;
  align-items: center;
  justify-content: space-between;

  min-width: 0;
  min-height: 44px;

  gap: 12px;
  padding: 7px 10px;

  background: #fff;
  border-bottom: 1px solid #e8e8e8;
}

.entry-image-preview-head > div {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 6px;
}

.entry-image-preview-head strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.entry-image-preview-body {
  display: flex;
  min-width: 0;
  min-height: 0;

  align-items: center;
  justify-content: center;

  overflow: auto;
  padding: 10px;

  background: linear-gradient(45deg, #181818 25%, transparent 25%),
    linear-gradient(-45deg, #181818 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #181818 75%),
    linear-gradient(-45deg, transparent 75%, #181818 75%), #101010;

  background-size: 20px 20px;

  background-position: 0 0, 0 10px, 10px -10px, -10px 0;
}

.entry-image-preview-body img {
  display: block;

  width: auto;
  height: auto;

  max-width: 100%;
  max-height: 100%;

  object-fit: contain;
}

.entry-image-preview-image {
  position: relative;

  transition: transform 0.12s ease-out;

  user-select: none;
  -webkit-user-drag: none;

  will-change: transform, left, top;
}

.entry-image-preview-foot {
  padding: 6px 10px;

  color: rgba(255, 255, 255, 0.72);

  background: #111;
  border-top: 1px solid #333;

  font-size: 11px;
}

/* ===== FIX CHIỀU CAO DRAWER VÀ LOG SCROLL ===== */

.entry-detail-spin,
.entry-detail-spin ::v-deep .ant-spin-nested-loading,
.entry-detail-spin ::v-deep .ant-spin-container {
  width: 100%;
  height: 100%;
  min-height: 0;
}

.entry-detail-layout {
  position: relative;
  display: grid !important;
  grid-template-columns: minmax(0, 1fr) 360px !important;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden !important;
}

.entry-detail-main {
  display: grid !important;
  grid-template-rows: minmax(0, 1fr) auto !important;
  min-width: 0;
  min-height: 0;
  height: 100%;
  overflow: hidden !important;
}

.entry-detail-scroll {
  min-width: 0;
  min-height: 0;
  height: auto !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.entry-action-footer {
  position: relative !important;
  inset: auto !important;
  z-index: 20;
  flex: none !important;
  margin: 0 !important;
}

/*
 * Scroll nằm ở wrapper ngoài.
 * Không phụ thuộc class hay layout bên trong EntryLogPanel.
 */
.entry-log-viewport {
  width: 360px;
  min-width: 0;
  min-height: 0;
  height: 100%;
  overflow-x: hidden;
  /* overflow-y: scroll;
    overscroll-behavior: contain;
    scrollbar-gutter: stable; */
  background: #fff;
  border-left: 1px solid #e8e8e8;
}

.entry-log-viewport > * {
  width: 100%;
  min-height: max-content;
}
.entry-image-preview-body {
  position: relative;
}

.entry-image-preview-tools {
  position: absolute;
  z-index: 5;
  top: 10px;
  left: 10px;

  display: flex;
  align-items: center;
  gap: 6px;
}
/*
 * Gỡ các height/overflow nội bộ có thể khóa scroll ngoài.
 */
/* .entry-log-viewport ::v-deep .entry-log-panel,
.entry-log-viewport ::v-deep .ant-spin-nested-loading,
.entry-log-viewport ::v-deep .ant-spin-container {
    height: auto !important;
    min-height: 0 !important;
    overflow: visible !important;
} */
.entry-log-viewport ::v-deep .entry-log-panel {
  width: 100%;
  height: 100%;
  min-height: 0;
}

@media (max-width: 1366px) {
  .entry-detail-layout {
    grid-template-columns: minmax(0, 1fr) 320px !important;
  }

  .entry-log-viewport {
    width: 320px;
  }
}

/*
 * Thu gọn toàn bộ LogPanel:
 * cột phải co thật xuống 42px để phần Entry bên trái nở ra.
 */
.entry-detail-layout.entry-detail-layout--log-collapsed {
  grid-template-columns: minmax(0, 1fr) 42px !important;
}

.entry-log-viewport.entry-log-viewport--collapsed {
  width: 42px !important;
  min-width: 42px;
  overflow: hidden;
}

.supervisor-inline--review {
  background: #fff7e6;
  border-color: #fa8c16;
  box-shadow: inset 3px 0 0 #fa8c16;
}

.supervisor-inline--review .supervisor-inline__head {
  background: #fff1d6;
}

.supervisor-inline--review .supervisor-inline__comment {
  color: #ad4e00;
  font-weight: 600;
  overflow: visible;
  text-overflow: initial;
  white-space: normal;
}

.supervisor-review-label {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 4px;
  color: #d46b08;
  font-size: 11px;
  font-weight: 700;
}

.supervisor-comment-readonly {
  min-height: 32px;
  padding: 5px 7px;
  color: rgba(0, 0, 0, 0.65);
  white-space: pre-wrap;
}

.supervisor-inline__comment .ant-input {
  resize: vertical;
  font-size: 12px;
}

.supervisor-inline--review {
  background: #fff7e6;
  border-color: #fa8c16;
  box-shadow: inset 3px 0 0 #fa8c16;
}

.supervisor-inline--review .supervisor-inline__comment {
  background: #fff7e6;
  color: #ad4e00;
  white-space: normal;
}

.supervisor-inline--review .ant-input {
  background: #fffdf5;
  border-color: #fa8c16;
}

.supervisor-review-label {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 4px;
  color: #d46b08;
  font-size: 11px;
  font-weight: 700;
}
/* =========================================================
 * READONLY / DISABLED - GIỮ GIAO DIỆN SÁNG
 * ========================================================= */

/* Input disabled */
.dense-form ::v-deep .ant-input[disabled] {
  color: rgba(0, 0, 0, 0.85);
  background: #fff;
  border-color: #d9d9d9;
  cursor: default;
  opacity: 1;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.85);
}

/* Select disabled */
.dense-form ::v-deep .ant-select-disabled {
  color: rgba(0, 0, 0, 0.85);
  opacity: 1;
}

.dense-form ::v-deep .ant-select-disabled .ant-select-selection {
  background: #fff;
  border-color: #d9d9d9;
  cursor: default;
}

.dense-form ::v-deep .ant-select-disabled .ant-select-selection-selected-value {
  color: rgba(0, 0, 0, 0.85);
}

/* DatePicker disabled */
.dense-form ::v-deep .ant-calendar-picker-input[disabled] {
  color: rgba(0, 0, 0, 0.85);
  background: #fff;
  cursor: default;
  opacity: 1;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.85);
}
.dense-field--cashout
  ::v-deep
  .payout-voucher.ant-radio-button-wrapper-checked {
  color: #fff !important;
  background: #1890ff !important;
  border-color: #1890ff !important;
}

.dense-field--cashout ::v-deep .payout-cash.ant-radio-button-wrapper-checked {
  color: #fff !important;
  background: #52c41a !important;
  border-color: #52c41a !important;
}

.dense-field--cashout
  ::v-deep
  .payout-cash.ant-radio-button-wrapper-checked::before {
  background: #52c41a !important;
}

.voucher-dlr-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 16px;
  margin: 8px 0 12px;
  padding: 10px 12px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background: #fafafa;
}

.voucher-dlr-grid .voucher-info-row {
  margin: 0;
}

</style>
